import { render, staticRenderFns } from "./ImgProductHorizontal.vue?vue&type=template&id=4444974e&"
import script from "./ImgProductHorizontal.vue?vue&type=script&lang=js&"
export * from "./ImgProductHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ImgProductHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports